import { render, staticRenderFns } from "./DebtorsV4.vue?vue&type=template&id=47137782&scoped=true"
import script from "./DebtorsV4.vue?vue&type=script&lang=js"
export * from "./DebtorsV4.vue?vue&type=script&lang=js"
import style0 from "./DebtorsV4.vue?vue&type=style&index=0&id=47137782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47137782",
  null
  
)

export default component.exports